module["exports"] = [
  "#{female_prefix}",
  "#{male_prefix}"
];
